import storeRequest from './request/storeRequest';

function getFees(params) {
  return storeRequest.get('/report/estimated-profit/by-store', { params });
}

function updateFee(id, params) {
  return storeRequest.patch(`/report/estimated-profit/${id}/ads-fee-by-store`, params);
}

function createFee(params) {
  return storeRequest.post('/report/estimated-profit/add-fee-by-store', params);
}

function makeOwner() {
  return storeRequest.post('/report/estimated-profit/make-owner-store');
}

// New API version
function getAvailableAccounts(params) {
  return storeRequest.get('/users/ads-accounts/account-available', { params });
}

function createFeeDetail(params) {
  return storeRequest.post('/report/estimated-profit/add-fee-detail-by-store', params);
}

function updateFeeDetail(id, params) {
  return storeRequest.patch(`/report/estimated-profit/${id}/ads-fee-detail-by-store`, params);
}

function getAdsFeeDetail(params) {
  return storeRequest.get('/report/estimated-profit/ads-fee-detail', { params });
}

export const addFeeApi = {
  getFees,
  updateFee,
  createFee,
  makeOwner,
  getAvailableAccounts,
  createFeeDetail,
  updateFeeDetail,
  getAdsFeeDetail,
};
